import { useEffect, useState } from 'react'
import { Button, Card } from 'react-bootstrap'
import demoGameCard from 'assets/images/demo-gamecard.svg'
import { useTranslation } from 'react-i18next'
import isHotGameCard from 'assets/images/gamecard-ishot.svg'
import { PATHS } from 'config/routes'
import { Link, useLocation } from 'react-router-dom'
import { useAtom } from 'jotai'
import { roomImageAtom, roomTitleAtom } from 'config/store'
import ModalHelpPlay from 'components/Modal/ModalHowtoplay/ModalHelpPlay'

function GameCard({
	type = '',
	data,
	isSmall,
	padding,
	setItemSelect,
	isHot,
	idGame = 0,
	isMedium,
}) {
	const { t } = useTranslation()
	const [, setRoomTitle] = useAtom(roomTitleAtom)
	const [, setRoomImage] = useAtom(roomImageAtom)
	const [scollOnTop, setScollOnTop] = useState(false)
	const [show, setShow] = useState(false)

	const { pathname } = useLocation()
	// useEffect(() => {
	// 	console.log('run123')
	// 	window.scrollTo({
	// 		top: 0,
	// 		left: 0,
	// 		behavior: 'smooth',
	// 	})
	// }, [scollOnTop])

	function handleRoomTitle() {
		setItemSelect && setItemSelect(data)
		setRoomTitle(data?.name)
		setRoomImage(demoGameCard)
		setScollOnTop(!scollOnTop)
	}

	return (
		<Card
			className={`game-card ${isSmall ? 'small-game-card' : isMedium ? 'medium-game-card' : ''
				}`}
		>
			<Link
				onClick={
					type === 'how-to-play'
						? () => {
							setShow(true)
						}
						: null
				}
				to={
					type === 'how-to-play'
						? "/"
						: PATHS.ROOM_PAGE.replace(':roomId', data?.id)
				}
				replace
				state={{ previous: pathname }}
			>
				<Card.Img onClick={handleRoomTitle} variant="top" src={data?.image} />
				{!isHot ? null : (
					<img
						src={isHotGameCard}
						className="hot-gamecard"
						alt="Hot game card"
					/>
				)}
			</Link>
			<Card.Body className={padding}>
				<div>
					<Link
						onClick={
							type === 'how-to-play'
								? () => {
									setShow(true)
								}
								: null
						}
						// to={
						// 	type === 'how-to-play'
						// 		? "/"
						// 		: PATHS.ROOM_PAGE.replace(':roomId', data?.id)
						// }
						to={
							data?.id === 1 ?
								process.env.REACT_APP_LINK_WEB_MINERGOLD :
								data?.id === 2 ? process.env.REACT_APP_LINK_WEB_KNIFE :
									process.env.REACT_APP_LINK_WEB_BEATMOUSE
						}
						target="_blank"
					>
						<Card.Title onClick={handleRoomTitle}>{data?.name}</Card.Title>
					</Link>
					<Card.Text>
						{t('game_card.number_playing').replace('_NUMBER_', data?.player)}
					</Card.Text>
				</div>

				<Link
					// to={
					// 	type === 'how-to-play'
					// 		? "/"
					// 		: PATHS.ROOM_PAGE.replace(':roomId', data?.id)
					// }
					to={
						data?.id === 1 ?
							process.env.REACT_APP_LINK_WEB_MINERGOLD :
							data?.id === 2 ? process.env.REACT_APP_LINK_WEB_KNIFE :
								process.env.REACT_APP_LINK_WEB_BEATMOUSE
					}
					target="_blank"
					replace
					state={{ previous: pathname }}
				>
					<Button
						onClick={
							type === 'how-to-play'
								? () => {
									setShow(true)
								}
								: handleRoomTitle
						}
						variant="primary"
					>
						{type === 'how-to-play'
							? t('game_card.how_to_play_btn')
							: t('game_card.play_btn')}
					</Button>
				</Link>
			</Card.Body>
			{/* TODO: change img to button for better view */}
			<ModalHelpPlay
				show={show}
				onHide={() => {
					setShow(false)
				}}
				idGame={idGame}
			/>
		</Card>
	)
}

export default GameCard
